<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="450"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="wrapper-form-crud overflow-y-auto">               
            <v-form>
                <v-card class="padding-bootom-0">
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col :cols="12">
                                    <v-autocomplete
                                        label="Unidad de medida"
                                        :items="units"
                                        v-model="assetForm.unit_id"
                                        outlined
                                        dense
                                        hide-details="auto"
                                    ></v-autocomplete>
                                </v-col>                                
                            </v-row>
                            <v-row>
                                <v-col :cols="12">
                                    <v-text-field v-model="assetForm.name" 
                                        ref="name"
                                        label="Nombre"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        :rules="[() => !!assetForm.name || 'Es necesario ingresar un nombre']"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :cols="12">
                                    <v-text-field v-model="assetForm.description" 
                                        label="Descripción"
                                        outlined
                                        dense
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>                                    
                            </v-row>
                            <v-row>
                                <v-col :cols="12">
                                    <v-text-field v-model="assetForm.useful_life" 
                                        label="Vida útil" 
                                        type="number" 
                                        suffix="años"
                                        outlined
                                        dense
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>                                    
                            </v-row>
                            <v-row>
                                <v-col :cols="12">
                                    <v-text-field v-model="assetForm.quantity" 
                                        label="Cantidad"
                                        outlined
                                        dense
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>                                    
                            </v-row>                            
                        </v-container>
                    </v-card-text>

                </v-card>
                
                <div class="mt-3 pt-3">
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <v-btn color="error"
                                    @click="closeForm()"
                                    block
                                >Cancelar</v-btn>
                            </v-col>
                            <v-col cols="6">
                                <v-btn v-if="actionCrud === 'create'" 
                                    color="success"
                                    @click="addAsset()"
                                    block
                                >Guardar</v-btn>
                                <v-btn v-else 
                                    color="primary"
                                    @click="modifyAsset()"
                                    block
                                >Actualizar</v-btn>
                            </v-col>
                        </v-row>
                    </template>                    
                </div>                
            </v-form>
        </div>
    </v-navigation-drawer>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex';

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'CreateOrUpdate',
    computed: {
        ...mapState('assets', [
            'assets',
            'asset',
            'assetId'
        ]),
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
            assetForm: {
                id: null,
                unit_id: null,
                name: null,
                description: null,
                useful_life: null,
                quantity: null
            },
            units: []
        }
    },
    methods: {
        ...mapActions('assets', [
            'getAssets',
            'createAsset',
            'updateAsset'
        ]),
        ...mapMutations('assets', [
            'setAsset',
            'setAssetId'
        ]),
        async showForm(title, action) {
            await this.clearform()
            this.titleForm = title
            this.actionCrud = action
            if (this.actionCrud === 'update') {
                this.setAssetId(this.asset.id)
                this.setAssetForm(this.asset)
            }
            this.drawer = !this.drawer
        },
        clearform() {
            this.assetForm.id = null
            this.assetForm.unit_id = null
            this.assetForm.name = null
            this.assetForm.description = null
            this.assetForm.useful_life = null
            this.assetForm.quantity = null
            this.clearErrors();
        },
        setAssetForm(asset) {
            this.assetForm.id = asset.id
            this.assetForm.unit_id = asset.unit_id
            this.assetForm.name = asset.name
            this.assetForm.description = asset.description
            this.assetForm.useful_life = asset.useful_life
            this.assetForm.quantity = asset.quantity
        },
        closeForm() {
            this.drawer = false
        },
        async addAsset() {
            if (!this.existErrors()) {
                this.setAsset(this.assetForm)
                await this.createAsset()
                this.closeForm()
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'REGISTRO DE ACTIVO',
                    text: 'Activo registrado de forma correcta.'
                });
            }
        },
        async modifyAsset() {
            if (!this.existErrors()) {
                this.setAsset(null)
                this.setAsset(this.assetForm)
                await this.updateAsset()
                this.closeForm()
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'ACTUALIZACIÓN DE ACTIVO',
                    text: 'Activo actualizado de forma correcta.'
                });
            }             
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.assetForm).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.assetForm[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.assetForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        }
    },
    mounted() {
        apiService.getUnitsDropdown().then((response) => {
            this.units = response.data;            
        });
    }
}
</script>

<style scoped>

</style>